import { whatsappLanguages } from "lopermut"
import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

export function useLanguageLabel() {
  const { i18n } = useTranslation()

  const languageNames = useMemo(
    () => new Intl.DisplayNames([i18n.language], { type: "language", languageDisplay: "standard" }),
    [i18n.language],
  )

  return useCallback(
    (code: string) => {
      const label = languageNames.of(code.replace("_", "-"))

      return label ? label.charAt(0).toUpperCase() + label.slice(1) : code
    },
    [languageNames],
  )
}

export function useLanguageOptions() {
  const { i18n } = useTranslation()
  const languageLabel = useLanguageLabel()

  return useMemo(
    () =>
      whatsappLanguages
        .map(({ value }) => ({ value, label: languageLabel(value) }))
        .sort((first, second) => first.label.localeCompare(second.label, i18n.language)),
    [languageLabel, i18n.language],
  )
}
